/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MarketShoppingBasketIcon16Light } from './MarketShoppingBasketIcon16Light';
import { MarketShoppingBasketIcon16Regular } from './MarketShoppingBasketIcon16Regular';
import { MarketShoppingBasketIcon16Solid } from './MarketShoppingBasketIcon16Solid';
import { MarketShoppingBasketIcon20Light } from './MarketShoppingBasketIcon20Light';
import { MarketShoppingBasketIcon20Regular } from './MarketShoppingBasketIcon20Regular';
import { MarketShoppingBasketIcon20Solid } from './MarketShoppingBasketIcon20Solid';
import { MarketShoppingBasketIcon24Regular } from './MarketShoppingBasketIcon24Regular';
import { MarketShoppingBasketIcon24Solid } from './MarketShoppingBasketIcon24Solid';
import { MarketShoppingBasketIcon32Regular } from './MarketShoppingBasketIcon32Regular';
import { MarketShoppingBasketIcon64Regular } from './MarketShoppingBasketIcon64Regular';
var sizes = {
    16: {
        light: MarketShoppingBasketIcon16Light,
        regular: MarketShoppingBasketIcon16Regular,
        solid: MarketShoppingBasketIcon16Solid,
    },
    20: {
        light: MarketShoppingBasketIcon20Light,
        regular: MarketShoppingBasketIcon20Regular,
        solid: MarketShoppingBasketIcon20Solid,
    },
    24: {
        regular: MarketShoppingBasketIcon24Regular,
        solid: MarketShoppingBasketIcon24Solid,
    },
    32: {
        regular: MarketShoppingBasketIcon32Regular,
    },
    64: {
        regular: MarketShoppingBasketIcon64Regular,
    },
};
export var MarketShoppingBasketIcon = forwardRef('MarketShoppingBasketIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
